import { render, staticRenderFns } from "./RoasterAvailabilitySettings.vue?vue&type=template&id=1d4b6d8e&scoped=true&"
import script from "./RoasterAvailabilitySettings.vue?vue&type=script&lang=ts&"
export * from "./RoasterAvailabilitySettings.vue?vue&type=script&lang=ts&"
import style0 from "./RoasterAvailabilitySettings.vue?vue&type=style&index=0&id=1d4b6d8e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4b6d8e",
  null
  
)

export default component.exports